import { useQuery } from '@tanstack/react-query';
import { CountriesApiAdapter, Country, CountryOption } from '@shared/adapters/CountriesApiAdapter';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services';

const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000; // 1 semana

export const useCountries = () => {
  const adapter = new CountriesApiAdapter(createHttpClient(apiClientWH));

  // Hook para países completos
  const countriesQuery = useQuery<Country[]>({
    queryKey: ['countries'],
    queryFn: () => adapter.getCountries(),
    staleTime: WEEK_IN_MS, // Los países no cambian, cache por 1 semana
    gcTime: WEEK_IN_MS,
    retry: 3,
  });

  // Hook para opciones de países (para selects)
  const countryOptionsQuery = useQuery<CountryOption[]>({
    queryKey: ['countries-options'],
    queryFn: () => adapter.getAll(),
    staleTime: WEEK_IN_MS,
    gcTime: WEEK_IN_MS,
    retry: 3,
  });

  return {
    countries: countriesQuery.data || [],
    countryOptions: countryOptionsQuery.data || [],
    loading: countriesQuery.isLoading || countryOptionsQuery.isLoading,
    error: countriesQuery.error?.message || countryOptionsQuery.error?.message || null,
    refetch: () => {
      countriesQuery.refetch();
      countryOptionsQuery.refetch();
    },
  };
};